(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["belle-spring-effects"] && !Shopify.designMode) return;
  try {
    (() => {
    const layer = document.getElementById('belle-spring-effects');
    if (!layer || layer.dataset.ready === 'true') return;
    const canvas = layer.querySelector('canvas');
    const context = canvas.getContext('2d');
    if (!context) return;
    layer.dataset.ready = 'true';
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const phone = window.matchMedia('(max-width: 749px)');
    const storageKey = 'belle-spring-petals';
    let frame = 0;
    let petals = [];
    let blossoms = [];
    let width = 0;
    let height = 0;
    let bounds;
    let lastShop = -Infinity;
    let lastCart = -Infinity;
    let lastView = -Infinity;
    const random = (minimum, maximum) => minimum + Math.random() * (maximum - minimum);
    const ease = (value) => 1 - Math.pow(1 - Math.max(0, Math.min(1, value)), 3);

    function finish() {
      cancelAnimationFrame(frame);
      frame = 0;
      petals = [];
      blossoms = [];
      context.clearRect(0, 0, width, height);
      window.removeEventListener('resize', resize);
      // Release the canvas backing store between bursts.
      canvas.width = 1;
      canvas.height = 1;
      if (typeof layer.hidePopover === 'function' && layer.matches(':popover-open')) {
        try { layer.hidePopover(); } catch {}
      }
      layer.hidden = true;
    }

    function resize() {
      if (layer.hidden) return;
      bounds = layer.getBoundingClientRect();
      width = Math.max(1, layer.clientWidth);
      height = Math.max(1, layer.clientHeight);
      const ratio = Math.min(window.devicePixelRatio || 1, phone.matches ? 1.5 : 2);
      canvas.width = Math.round(width * ratio);
      canvas.height = Math.round(height * ratio);
      context.setTransform(ratio, 0, 0, ratio, 0, 0);
    }

    function prepare() {
      if (motion.matches || document.hidden) return false;
      layer.hidden = false;
      if (typeof layer.showPopover === 'function') {
        try {
          if (!layer.matches(':popover-open')) layer.showPopover();
        } catch {
          layer.removeAttribute('popover');
        }
      } else layer.removeAttribute('popover');
      window.addEventListener('resize', resize, {passive: true});
      resize();
      return true;
    }

    // One gradient per petal size, created once and reused every frame.
    const gradients = new Map();
    function petalGradient(radius) {
      let gradient = gradients.get(radius);
      if (!gradient) {
        gradient = context.createLinearGradient(0, 0, 0, -radius);
        gradient.addColorStop(0, '#ce6b88');
        gradient.addColorStop(0.4, '#f3b9cb');
        gradient.addColorStop(1, '#ffe8ef');
        gradients.set(radius, gradient);
      }
      return gradient;
    }

    function drawPetal(radius, opening = 1) {
      context.save();
      context.scale(Math.max(0.1, opening), 1);
      context.fillStyle = petalGradient(radius);
      context.beginPath();
      context.moveTo(0, 1);
      context.bezierCurveTo(-radius * 0.2, -radius * 0.15, -radius * 0.66, -radius * 0.62, -radius * 0.35, -radius * 0.91);
      context.bezierCurveTo(-radius * 0.22, -radius * 1.05, -radius * 0.07, -radius * 0.98, 0, -radius * 0.86);
      context.bezierCurveTo(radius * 0.09, -radius * 1.04, radius * 0.28, -radius * 1.02, radius * 0.4, -radius * 0.86);
      context.bezierCurveTo(radius * 0.58, -radius * 0.52, radius * 0.18, -radius * 0.09, 0, 1);
      context.fill();
      context.restore();
    }

    function drawBlossom(blossom, elapsed) {
      const opening = ease(elapsed / 600);
      const alpha = Math.min(1, elapsed / 120, (3600 - elapsed) / 600);
      context.save();
      context.globalAlpha = Math.max(0, alpha);
      context.translate(blossom.x, blossom.y);
      context.rotate(blossom.angle);
      const size = 0.12 + opening * 0.88;
      context.scale(size, size);
      for (let i = 0; i < 5; i++) {
        context.save();
        context.rotate((i * Math.PI * 2) / 5);
        drawPetal(blossom.radius, 0.35 + opening * 0.65);
        context.restore();
      }
      context.strokeStyle = '#b95c7b';
      context.lineWidth = 0.7;
      context.fillStyle = '#b95c7b';
      for (let i = 0; i < 15; i++) {
        const angle = (i * Math.PI * 2) / 15;
        const radius = blossom.radius * (0.15 + 0.025 * (i % 3));
        const x = Math.cos(angle) * radius;
        const y = Math.sin(angle) * radius;
        context.beginPath();
        context.moveTo(0, 0);
        context.lineTo(x, y);
        context.stroke();
        context.beginPath();
        context.arc(x, y, 0.8, 0, Math.PI * 2);
        context.fill();
      }
      context.restore();
    }

    function schedule() {
      if (!frame) frame = requestAnimationFrame(draw);
    }

    function draw(now) {
      frame = 0;
      if (motion.matches || document.hidden || !layer.isConnected) {
        finish();
        return;
      }
      context.clearRect(0, 0, width, height);
      petals = petals.filter((petal) => now - petal.start < petal.duration);
      for (const petal of petals) {
        const elapsed = now - petal.start;
        if (elapsed < 0) continue;
        const seconds = elapsed / 1000;
        const progress = elapsed / petal.duration;
        context.save();
        context.globalAlpha = Math.max(0, Math.min(0.92, progress * 10, (1 - progress) * 4));
        context.translate(petal.x + petal.vx * seconds + Math.sin(seconds * 2.7 + petal.angle) * petal.sway, petal.y + petal.vy * seconds + 92 * seconds * seconds);
        context.rotate(petal.angle + petal.spin * seconds);
        context.scale(1, 0.68 + Math.sin(seconds * 4) * 0.2);
        drawPetal(petal.radius);
        context.restore();
      }
      blossoms = blossoms.filter((blossom) => now - blossom.start < 3600);
      for (const blossom of blossoms) drawBlossom(blossom, now - blossom.start);
      if (petals.length || blossoms.length) schedule();
      else finish();
    }

    function addPetals(count, x, y, rain) {
      const now = performance.now();
      for (let i = 0; i < count; i++) {
        petals.push({
          x: rain ? random(width * 0.08, width * 0.92) : x,
          y: rain ? random(18, 80) : y,
          vx: random(-45, 45),
          vy: rain ? random(20, 48) : random(-100, -35),
          radius: Math.round(random(7, 13)),
          angle: random(0, Math.PI * 2),
          spin: random(-2, 2),
          sway: random(8, 22),
          start: now + (rain ? i * 23 : i * 12),
          duration: rain ? random(1500, 1950) : random(1000, 1400),
        });
      }
      petals = petals.slice(-70);
      schedule();
    }

    function rain() {
      if (!prepare()) return;
      addPetals(width < 600 ? 18 : 26, 0, 0, true);
    }

    async function cartBloom(source, burst) {
      const cartDrawer = document.querySelector('cart-drawer-component');
      const cartDialog = cartDrawer?.closest('dialog[open]');
      const sourceDialog = source instanceof Element ? source.closest('dialog[open]') : null;
      const dialog = cartDialog || sourceDialog;
      if (dialog) {
        await Promise.allSettled(dialog.getAnimations().map((animation) => animation.finished));
        if (!dialog.open || document.hidden) return;
      }
      if (!prepare()) return;
      const cartIcon = document.querySelector('.header-actions__cart-icon');
      const icon = cartIcon?.getBoundingClientRect();
      const drawerBounds = dialog?.getBoundingClientRect();
      const scaleX = bounds.width > 0 ? width / bounds.width : 1;
      const scaleY = bounds.height > 0 ? height / bounds.height : 1;
      const x = Math.max(38, Math.min(width - 38, drawerBounds ? (drawerBounds.right - bounds.left - 88) * scaleX : icon ? (icon.left - bounds.left + icon.width / 2) * scaleX - 34 : width - 60));
      const y = Math.max(38, Math.min(height - 38, drawerBounds ? (drawerBounds.top - bounds.top + 54) * scaleY : icon ? (icon.top - bounds.top + icon.height / 2) * scaleY + 26 : 66));
      blossoms = [{x, y, radius: 28, angle: random(-0.4, 0.4), start: performance.now()}];
      if (burst) addPetals(7, x, y, false);
      schedule();
    }

    document.addEventListener('click', (event) => {
      if (motion.matches || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const link = event.target instanceof Element ? event.target.closest('a[data-petals][href]') : null;
      if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
      const destination = new URL(link.href, window.location.href);
      if (destination.origin !== window.location.origin || !/^https?:$/.test(destination.protocol)) return;
      if (performance.now() - lastShop < 650) return;
      lastShop = performance.now();
      if (destination.pathname !== window.location.pathname || destination.search !== window.location.search) {
        try {
          sessionStorage.setItem(storageKey, JSON.stringify({path: destination.pathname, time: Date.now()}));
        } catch {}
      }
      rain();
    });

    document.addEventListener('shopify:cart:lines-update', (event) => {
      if (event.action !== 'add' || !event.promise || typeof event.promise.then !== 'function') return;
      const source = event.target;
      event.promise.then((result) => {
        if (result?.detail?.didError || !result?.cart || motion.matches || document.hidden) return;
        if (performance.now() - lastCart < 650) return;
        lastCart = performance.now();
        requestAnimationFrame(() => cartBloom(source, true));
      }).catch(() => {});
    });

    function handleCartView(event) {
      if (motion.matches || performance.now() - lastView < 1200 || performance.now() - lastCart < 900) return;
      lastView = performance.now();
      requestAnimationFrame(() => cartBloom(event.target, false));
    }

    document.addEventListener('shopify:cart:view', handleCartView);
    document.addEventListener('theme-drawer:open', (event) => {
      if (event.target instanceof Element && event.target.id === 'cart-drawer') handleCartView(event);
    });
    document.addEventListener('theme-drawer:close', (event) => {
      if (event.target instanceof Element && event.target.id === 'cart-drawer') finish();
    });

    window.addEventListener('pagehide', finish);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) finish();
    });
    motion.addEventListener('change', () => {
      if (motion.matches) finish();
    });

    // Replay on the page we landed on, but only once it has loaded and the browser is idle,
    // so the petals never compete with the main image.
    function afterPageSettles(callback) {
      const run = () => {
        if ('requestIdleCallback' in window) requestIdleCallback(callback, {timeout: 3000});
        else setTimeout(callback, 400);
      };
      if (document.readyState === 'complete') run();
      else window.addEventListener('load', run, {once: true});
    }

    try {
      const pending = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      sessionStorage.removeItem(storageKey);
      if (pending && pending.path === window.location.pathname && Date.now() - pending.time < 10000 && Date.now() >= pending.time) {
        afterPageSettles(rain);
      }
    } catch {}
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const WIDTHS = [240, 352, 832, 1200, 1600, 1920, 2560, 3840];

    /** @param {Element} gallery */
    const hydrate = (gallery) => {
      for (const el of gallery.querySelectorAll('[data-deferred-src]')) {
        if (!(el instanceof HTMLElement)) continue;
        const { deferredSrc, deferredAlt = '', deferredSizes = '', deferredFocal } = el.dataset;
        if (!deferredSrc) continue;
        const url = new URL(deferredSrc, location.href);
        const srcset = WIDTHS.map((w) => {
          url.searchParams.set('width', String(w));
          return `${url} ${w}w`;
        }).join(', ');
        url.searchParams.set('width', '3840');

        const img = document.createElement('img');
        img.className = 'product-media__image';
        img.loading = 'lazy';
        img.alt = deferredAlt;
        img.sizes = deferredSizes;
        img.srcset = srcset;
        img.src = url.toString();
        if (deferredFocal) img.style.cssText = `--focal-point: ${deferredFocal};`;
        el.append(img);

        delete el.dataset.deferredSrc;
        delete el.dataset.deferredAlt;
        delete el.dataset.deferredSizes;
        delete el.dataset.deferredFocal;
      }
    };

    /** @param {Event} event */
    const onInteract = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const gallery = target.closest('.card-gallery');
      if (gallery) hydrate(gallery);
    };

    for (const type of ['pointerover', 'pointerdown', 'touchstart', 'focusin']) {
      document.addEventListener(type, onInteract, { passive: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
